import { useState } from 'react';
import axios from 'axios';
import './Feedback.css';
import { useMsal } from '@azure/msal-react';

const Feedback = () => {
  const [sapFeedbackComment, setSapFeedbackComment] = useState('');
  const [sapFeedbackSubmitModal, setSapFeedbackSubmitModal] = useState(false);
  const [sapFeedbackSubmitMsg, setSapFeedbackSubmitMsg] = useState('');

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const handleSubmit = event => {
    event.preventDefault();
    if (process.env.NODE_ENV === 'production') {
      axios(
        {
          method: 'post',
          url: 'https://atci.lkm.eitacademy.accenture.com/ips-apis/feedback',
          data: {
            enterprise_id: activeAccount.idTokenClaims.enterpriseID,
            comment: sapFeedbackComment
          },
          headers: {
            'Authorization': localStorage.getItem("token"),
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          setSapFeedbackSubmitModal(true);
          setSapFeedbackSubmitMsg(response.data.message);
        })
        .catch((error) => {
          setSapFeedbackSubmitMsg(error.data.message);
        })
    }
    else {
      alert('Feedback submission not allowed in localhost!');
    }
  }

  return (
    <div>
      <div className="sap_feedback_banner">
        <img src={process.env.PUBLIC_URL + "/images/SAP/sap_feedback.png"} alt="Emotion Captures Banner" />
      </div>
      <div id="feedback_form">
        <form onSubmit={handleSubmit}>
          <div className="feedback">
            <label for="exampleFormControlTextarea1">
              <h6 className="textarea-label">Please share your views, suggestions and inputs on SAP learning services</h6>
            </label>
            <textarea
              className="sap-feedback-txtarea"
              id="exampleFormControlTextarea1"
              rows="3"
              onChange={event => {
                setSapFeedbackComment(event.target.value);
              }}
            >
              {sapFeedbackComment}
            </textarea>
            <input type="submit" className="sap-feedback-btn" />
          </div>
        </form>
      </div>
      {sapFeedbackSubmitModal && <div className='sap-feedback-sub-bg-modal'>
        <div className='sap-feedback-sub-modal'>
          <div className='sap-feedback-sub-msg'>{sapFeedbackSubmitMsg}</div>
          <div className='sap-feedback-sub-modal-close-div'><button className='sap-feedback-sub-modal-close-btn' onClick={() => { setSapFeedbackSubmitModal(false); setSapFeedbackComment('') }}>Ok</button></div>
        </div>
      </div>}
    </div>
  );
}

export default Feedback;
